class BritishColumbiaObstetricalFileTests {
    // row 1
    public IsImmuneToRubella?: boolean;
    public RubellaImmuneInternationalUnitsPerMilliliter?: number;
    public IsPostpartumVaccineRequired: boolean;

    // row 2
    public IsHumanImmunodeficiencyVirusPositive?: boolean;
    public ThirdTrimesterRepeatIfHumanImmunodeficiencyVirusIsHighRisk: boolean;
    public HumanImmunodeficiencyVirusComments: string;

    // row 3
    public IsReactiveToSyphilis?: boolean;
    public SyphilisComments: string;

    // row 4
    public IsReactiveToHepatitisBSurfaceAntigen?: boolean;
    public HepatitisBVirusDnaInternationalUnitsPerMilliliter?: number;
    public HasPartnerOrHouseholdContact: boolean;
    public IsAntiViralTherapyRequired: boolean;
    public IsNewbornVaccineRequired: boolean;
    public IsNewbornHepatitisBImmuneGlobulinRequired: boolean;

    // row 5
    public IsGonorrheaPositive?: boolean;
    public ThirdTrimesterRepeatIfGonorrheaIsPositive: boolean;
    public GonorrheaComments: string;

    // row 6
    public IsChlamydiaPositive?: boolean;
    public ThirdTrimesterRepeatIfChlamydiaIsPositive: boolean;
    public ChlamydiaComments: string;

    // row 7
    public IsUrineCultureAndSensitivityPositive?: boolean;
    public UrineCulture: string;
    public UrineCultureAndSensitivityComments: string;

    // row 8
    public IsGestationalDiabetesMellitusTestDeclined: boolean;
    public IsDietControlled: boolean;
    public IsInsulinRequired: boolean;
    public IsGlucoseChallengeTestPositive?: boolean;
    public GlucoseChallengeTestMillimolesPerLiterAt1Hour?: number;
    public IsGlucoseToleranceTestPositive?: boolean;
    public GlucoseToleranceTestMillimolesPerLiterFasting?: number;
    public GlucoseToleranceTestMillimolesPerLiterAt1Hour?: number;
    public GlucoseToleranceTestMillimolesPerLiterAt2Hour?: number;
    public GlucoseToleranceTestMillimolesPerLiterAt3Hour?: number; // No longer needed in new form.

    // row 9
    public IsGroupBStreptococcusPositive?: boolean;
    public GroupBStreptococcusTestDate: Date;
    public GroupBStreptococcusCopyToHospital: boolean;

    // row 10
    public OtherTests: string;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileTests>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileTests };
